import type { GridOptions } from '../types'

export interface ResolvedInfiniteScroll {
  enabled: boolean
  pageSize: number
  threshold: number
}

const DEFAULT_PAGE_SIZE = 50
const DEFAULT_THRESHOLD = 80

/**
 * 解析 infiniteScroll 配置。
 * 默认开启；仅 `infiniteScroll: false` 时退回传统分页。
 */
export function resolveInfiniteScroll(
  options?: Pick<GridOptions, 'infiniteScroll' | 'params'> | null
): ResolvedInfiniteScroll {
  const raw = options?.infiniteScroll
  if (raw === false) {
    return {
      enabled: false,
      pageSize: DEFAULT_PAGE_SIZE,
      threshold: DEFAULT_THRESHOLD,
    }
  }
  if (raw === true || raw == null) {
    return {
      enabled: true,
      pageSize: Number(options?.params?.pageSize) || DEFAULT_PAGE_SIZE,
      threshold: DEFAULT_THRESHOLD,
    }
  }
  return {
    enabled: true,
    pageSize:
      raw.pageSize
      ?? (Number(options?.params?.pageSize) || DEFAULT_PAGE_SIZE),
    threshold: raw.threshold ?? DEFAULT_THRESHOLD,
  }
}

/** 默认 true；显式 false 关闭 */
export function isInfiniteScrollEnabled(
  options?: Pick<GridOptions, 'infiniteScroll'> | null
): boolean {
  return options?.infiniteScroll !== false
}
